module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "pt1"
    }
  }), _vm._v("Part One")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('em', [_vm._v("The Explorer")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0009-01.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('em', [_vm._v("There comes a time in every rightly constructed boy’s life when he has a raging desire to go somewhere and dig for hidden treasure.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_c('em', [_vm._v("—Mark Twain,")]), _vm._v(" The Adventures of Tom Sawyer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dda0d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780230337411_11_pt1.vue
// module id = 90
// module chunks = 0